module.exports = __webpack_public_path__ + "img/redchirp-square-large.dd60db13.png";